import { render, staticRenderFns } from "./WriteDoctors.vue?vue&type=template&id=2a1859d7&scoped=true"
import script from "./WriteDoctors.vue?vue&type=script&lang=js"
export * from "./WriteDoctors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1859d7",
  null
  
)

export default component.exports